import type { ReactNode } from "react";

// Same pattern as portfolio-risk-concentration's StepShell.tsx -- just keeps page
// content at a consistent max width, independent of any wizard/step concept.
export function PageShell({ children }: { children: ReactNode }) {
  return <div className="mx-auto w-full max-w-7xl px-6">{children}</div>;
}
